<template>
    <div class="app-layout">
        <HeadBar 
            @export-svg="triggerExport('export-svg')" 
            @export-pdf="triggerExport('export-pdf')" 
            @export-txt="triggerExport('export-txt')" 
            @import-txt="handleImportTxt" 
            @update-notation="handleUpdateNotation"
        />
        <div class="divider-line"></div>
        <MainLayout ref="mainLayout"/>
    </div>
</template>

<script>
import HeadBar from './HeadBar.vue';
import MainLayout from './MainLayout.vue';

export default {
    async created() {
        // 从sessionStorage恢复状态
        await this.$store.dispatch('restoreStateFromStorage');
    },
    components: {
        HeadBar,
        MainLayout
    },
    methods: {
        triggerExport(event) {
            // 确保 MainLayout 的引用存在
            if (this.$refs.mainLayout) {
                this.$refs.mainLayout.$emit(event); // 转发事件给 MainLayout
            } else {
                console.error("MainLayout reference not found!");
            }
        },
        handleImportTxt(content) {
            if (this.$refs.mainLayout) {
                this.$refs.mainLayout.importTxt(content);
            } else {
                console.error("App: MainLayout reference not found");
            }
        },
        handleUpdateNotation(notation) {
            if (this.$refs.mainLayout) {
                this.$refs.mainLayout.updateNotation(notation);
            } else {
                console.error("App: MainLayout reference not found");
            }
        }
    }
};
</script>

<style scoped>
.app-layout {
    width: 90%;
    margin: 20px auto;
    background-color: #ffffff;
    border: 1.5px solid #d3d3d3;
    border-radius: 5px;
    overflow: hidden;
}

.divider-line {
    height: 1px;
    background-color: #d3d3d3;
}
</style>